import { render, staticRenderFns } from "./SummaryForm.vue?vue&type=template&id=a5648f94&"
import script from "./SummaryForm.vue?vue&type=script&lang=js&"
export * from "./SummaryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports